<template>
  <div class="tab-bar">
    <i class="el-icon-arrow-left" @click="back"></i>
    <div>{{text}}</div>
  </div>
</template>

<script>
export default {
  name: 'BannerTop',
  props: ['text'],
  data () {
    return {
    }
  },
  methods: {
    back: function () {
      this.$router.go(-1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tab-bar {
  width: 100%;
  height: 3rem;
  background: #fff;
  border-bottom: 1px solid #ccc;
}
.tab-bar i {
  position: absolute;
  line-height: 3rem;
  padding-left: 0.5rem;
}
.tab-bar div {
  line-height: 3rem;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/BannerTop.vue